'use client';

import styles from '@/app/orders/components/FiltersToggleButton.style';

import { AppColors } from '@cmbg-traky-web/design-system';
import { Badge, Button } from 'antd';
import { useTranslation } from 'react-i18next';

export type FiltersToggleButtonProps = Readonly<{
  advancedVisible: boolean;
  onToggle: () => void;
  filterCount: number;
}>;

/**
 * A toggle button for showing and hiding advanced filters.
 *
 * @param {FiltersToggleButtonProps} props - The component props.
 *
 * @returns {JSX.Element} The rendered component.
 */
export function FiltersToggleButton({
  advancedVisible,
  onToggle,
  filterCount
}: FiltersToggleButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      type='default'
      onClick={onToggle}
      style={{
        ...styles.advancedButton,
        backgroundColor: advancedVisible ? AppColors.VA.PRIMARY._10_ : AppColors.VA.NEUTRALS.WHITE
      }}>
      {t('orders:advance-search.button')}&nbsp;
      {filterCount > 0 && <Badge count={filterCount} color={AppColors.VA.PRIMARY._50_} />}
      <i
        className='bi bi-chevron-down'
        style={{ transform: `rotate(${advancedVisible ? 180 : 0}deg)` }}
      />
    </Button>
  );
}
